var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace1Active(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45.19,
    r: 43.31,
    fill: "#ff2441"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.24,12.35a43.31,43.31,0,0,1-62.73,59A43.31,43.31,0,0,0,79.49,19a42.72,42.72,0,0,0-6.25-6.64Z",
    fill: "#eb213c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.48,60.45c5.76-5.34,18.4-13.61,31.62.08a2,2,0,0,1-1.41,3.37s-16.28-3.38-28.89,0C29.57,64.22,28.16,61.67,29.48,60.45Z",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.75,
    cy: 35.2,
    r: 6.31,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.25,
    cy: 35.2,
    r: 6.31,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,62.67c7.35-6.81,23.49-17.37,40.37.11a2.55,2.55,0,0,1-.07,3.6,2.52,2.52,0,0,1-1.72.71s-20.8-4.32-36.9,0C24.9,67.5,23.11,64.24,24.8,62.67Z",
    fill: "#7f1220"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1Active);
export default __webpack_public_path__ + "static/media/face_1_active.0b678cdf38dbb4610712d2dfe39d1277.svg";
export { ForwardRef as ReactComponent };